import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class ScrunchWhenSqueezed extends BaseOption {
  static label = "Scrunch on Squeeze";
  static userInterfaceComponent = {
    label: "Scrunch on Squeeze",
    component: inspectorTools.RADIO_BAR,
    props: {
      options: [
        {
          label: "Yes",
          value: "yes",
        },
        {
          label: "No",
          value: "no",
        },
      ],
    },
  };

  // "yes" (default) leaves flex-shrink unset (CSS 1); "no" -> noShrink prop -> flex-shrink:0.
  static defaultValue = "yes";
}
